import * as angular from 'angular';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { MemberSearchResponse } from '@mode/legacy/data-access-model-js';
import { Resource } from '@mode/shared/util-halogen';

/**
 * Temporary data access service for member search
 *
 * @todo move to a data access library
 */
export class MemberSearchService {
  static $inject = ['$http'];

  constructor(private $http: angular.IHttpService) {}

  searchMemberships(query = '', filter = '', page = 0, accountId: string): angular.IPromise<MemberSearchResponse> {
    const path = `/api/${accountId}/memberships/search`;
    const config = {
      params: {
        query: query,
        filter: filter,
        page: page,
      },
    };
    return this.$http.get(path, config).then((response) => {
      return new Resource(response.data) as any;
    });
  }
}
